export const MAIL = 'mail';
export const STORE = 'store';
export const PRINTERLESS_MAIL = 'printerless_mail';
export const NARVAR_CONCIERGE = 'concierge';
export const KEEP_THE_ITEM = 'keeptheitem';
export const BOXLESS = 'boxless';
export const CONCIERGE_PARTNERSHIP = 'concierge_partnership';
export const PICKUP = 'pickup';
export const LOCAL_PICKUP = 'local_pickup';
export const HAPPY_RETURNS = 'happy_returns';
export const HOME_PICKUP = 'home_pickup';
export const LOCKER_DROPOFF = 'locker_dropoff';
export const DROP_OFF = 'drop_off';
export const DIGITAL = 'digital';

export const METHODS_WITHOUT_PSSLS = [HAPPY_RETURNS];

export const METHODS_ON_LEGACY_EMAIL_API = [
  MAIL,
  STORE,
  NARVAR_CONCIERGE,
  CONCIERGE_PARTNERSHIP,
  KEEP_THE_ITEM,
  LOCAL_PICKUP,
];

export const PRINTERLESS_METHODS = [PRINTERLESS_MAIL, BOXLESS, HAPPY_RETURNS, LOCKER_DROPOFF];

export const METHODS_WITH_NPS_SCORES = [BOXLESS, LOCKER_DROPOFF];

// User Preferences
export const PREFERRED = 'PREFERRED';

export const METHODS_WITHOUT_ADDRESS = [DIGITAL];
